






































































































































import { Prop, Component, Vue } from "vue-property-decorator";
import EstimatePurchaseItem from "../presenters/estimate-purchase-item";
import EstimatePurchaseRow from "./EstimatePurchaseRow.vue";
import { ESTIMATE_ITEM_LEVEL } from "@/preferences";
import Decimal from "decimal.js";
import SelectOption from "@/common/ui/presenters/select-option";

@Component({
  computed: {
    ESTIMATE_ITEM_LEVEL() {
      return ESTIMATE_ITEM_LEVEL;
    }
  },
  components: {
    EstimatePurchaseRow
  }
})
export default class PurchaseOption extends Vue {
  @Prop({ required: true }) option!: EstimatePurchaseItem;
  @Prop({ required: true }) level!: number;
  @Prop({ required: true }) expenseCategoryOptions!: SelectOption[];
  @Prop({ required: true }) isShowNoteColumn!: boolean;

  handleCheckBox() {
    this.$nextTick(() => {
      this.$emit("afterCheckboxChange");
    });
  }

  get expenseCategory(): string {
    let optionSelected = this.expenseCategoryOptions.find(
      option => option.value === this.option.expenseCategoryId
    );
    if (optionSelected) {
      return optionSelected.text;
    }
    return "";
  }

  get profitAmount(): number {
    return this.option.totalPrice - this.option.loss;
  }

  get profitRatePercent(): string {
    if (!this.option.totalPrice) {
      return "0%";
    }
    return (
      new Decimal(this.option.totalPrice)
        .minus(this.option.loss)
        .div(this.option.totalPrice)
        .mul(100)
        .toFixed(1) + "%"
    );
  }

  isNegative(value: number): boolean {
    return value < 0;
  }
}
